module.exports = __webpack_public_path__ + "static/media/speakers.79ec637e.jpg";